export const NUMBER_MAX_DIGITS = 10;
export const numberPatterns = {
  NUMBER_DEC2_PATTERN: `[0-9{0,${NUMBER_MAX_DIGITS}}[.]{0,1}[0-9]{0,2}]`,
  NUMBER_INT_PATTERN: `[0-9]{0,${NUMBER_MAX_DIGITS}}`,
  NUMBER_INT_PATTERN_TREE_DIGITS: "[0-9]{1-3}",
};
export const GENERIC_ERROR = { status: 500 };
export const NOT_AVAILABLE = "Not Available";
